import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse } from "models";
import { StoreState } from "models/store";

const initialState: StoreState = {
  loading: false,
  data: {},
  storeData: {},
  BrandData: {},
  storeCharges: {},
  storeTaxes: {},
  KotData: {},
  MenuData: {},
  imageUrl: "",
  addUpdateLoading: false,
  imageLoading: false,
  kotLoading: false,
  message: "",
  success: false,
  kotSuccess: false,
  integration: {},
  roleOrders: {},
  constantsType: {},
  urbanPiperWebhooks: [],
  urbanPiperWebhooksLoading: false,
  setupWebhookLoading: false,
  singleWebhook: null,
  defaultWebhookEvents: [],
  defaultWebhookEventsLoading: false,
};

const storeSlice = createSlice({
  name: "store",
  initialState,
  reducers: {
    getStore(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getStoreSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = action.payload;
      state.success = action.payload.success;
    },
    getStoreFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload?.message;
      state.success = action.payload?.success;
    },
    getPlatformList(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getPlatformListSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.platformData = action.payload;
      state.success = action.payload?.success;
    },
    getPlatformListFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload?.message;
      state.success = action.payload?.success;
    },
    getStoreDetails(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getStoreDetailsSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.storeData = action.payload;
      state.success = action.payload?.success;
    },
    getStoreDetailsFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload?.message;
      state.success = action.payload?.success;
    },
    getBrandById(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getBrandByIdSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.BrandData = action.payload;
      state.success = action.payload?.success;
    },
    getBrandByIdFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload?.message;
      state.success = action.payload?.success;
    },
    getStoreCharges(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getStoreChargesSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.storeCharges = action.payload;
      state.success = action.payload?.success;
    },
    getStoreChargesFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload?.message;
      state.success = action.payload?.success;
    },
    getStoreTaxes(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getStoreTaxesSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.storeTaxes = action.payload;
      state.success = action.payload?.success;
    },
    getStoreTaxesFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload?.message;
      state.success = action.payload?.success;
    },
    getStoreKot(state, action: PayloadAction<ApiResponse>) {
      state.kotLoading = true;
      state.message = "";
    },
    getStoreKotSuccess(state, action: PayloadAction<ApiResponse>) {
      state.kotLoading = false;
      state.KotData = action.payload;
      state.kotSuccess = action.payload?.success;
    },
    getStoreKotFailed(state, action: PayloadAction<ApiResponse>) {
      state.kotLoading = false;
      state.message = action.payload?.message;
      state.kotSuccess = action.payload?.success;
    },
    getStoreMenu(state, action: PayloadAction<ApiResponse>) {
      state.menuLoading = true;
      state.message = "";
    },
    getStoreMenuSuccess(state, action: PayloadAction<ApiResponse>) {
      state.menuLoading = false;
      state.MenuData = action.payload;
      state.success = (action.payload as any)?.Sucess ?? action.payload?.success;
    },
    getStoreMenuFailed(state, action: PayloadAction<ApiResponse>) {
      state.menuLoading = false;
      state.message = action.payload?.message;
      state.success = (action.payload as any)?.Sucess ?? action.payload?.success;
    },
    addOrUpdateStore(state, action: PayloadAction<ApiResponse>) {
      state.addUpdateLoading = true;
      state.message = "";
      state.success = false;
    },
    addOrUpdateStoreSuccess(state, action: PayloadAction<ApiResponse>) {
      state.addUpdateLoading = false;
      state.message = action.payload?.message;
      state.success = action.payload?.success;
    },
    addOrUpdateStoreFailed(state, action: PayloadAction<ApiResponse>) {
      state.addUpdateLoading = false;
      state.message = action.payload?.message;
      state.success = action.payload?.success;
    },
    uploadStoreImage(state, action: PayloadAction<ApiResponse>) {
      state.imageLoading = true;
      state.message = "";
    },
    uploadStoreImageSuccess(state, action: PayloadAction<ApiResponse>) {
      state.imageLoading = false;
      state.imageUrl = action.payload?.data || (action.payload as any)?.url || "";
      state.success = action.payload?.success;
    },
    uploadStoreImageFailed(state, action: PayloadAction<ApiResponse>) {
      state.imageLoading = false;
      state.message = action.payload?.message;
      state.success = action.payload?.success;
    },
    clearData(state) {
      state.kotSuccess = false;
      state.menuLoading = false;
      state.addUpdateLoading = false;
      state.imageLoading = false;
      state.success = false;
      state.loading = false;
      state.message = "";
    },
    placeTestOrder(state, action: PayloadAction<any>) {
      // Saga trigger for placing test order
    },
    getIntegration(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getIntegrationSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.integration = action.payload;
      state.success = action.payload?.success;
    },
    getIntegrationFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload?.message;
      state.success = action.payload?.success;
    },
    getRoleOrders(state, action: PayloadAction<ApiResponse>) {
      // Saga trigger only
    },
    getRoleOrdersSuccess(state, action: PayloadAction<ApiResponse>) {
      state.roleOrders = action.payload;
    },
    getRoleOrdersFailed(state, action: PayloadAction<ApiResponse>) {
      state.message = action.payload?.message;
    },
    getConstantsType(state, action: PayloadAction<ApiResponse>) {
      // Saga trigger only
    },
    getConstantsTypeSuccess(state, action: PayloadAction<ApiResponse>) {
      state.constantsType = action.payload;
    },
    getConstantsTypeFailed(state, action: PayloadAction<ApiResponse>) {
      state.message = action.payload?.message;
    },
    getUrbanPiperWebhooks(state, action: PayloadAction<{ brandId: string; webhook_id?: number | string }>) {
      state.urbanPiperWebhooksLoading = true;
    },
    getUrbanPiperWebhooksSuccess(state, action: PayloadAction<any>) {
      state.urbanPiperWebhooksLoading = false;
      state.urbanPiperWebhooks = action.payload;
    },
    getUrbanPiperWebhooksFailed(state, action: PayloadAction<any>) {
      state.urbanPiperWebhooksLoading = false;
      state.message = action.payload?.message;
    },
    getSingleUrbanPiperWebhook(state, action: PayloadAction<{ brandId: string; webhook_id: number | string }>) {
      state.urbanPiperWebhooksLoading = true;
    },
    getSingleUrbanPiperWebhookSuccess(state, action: PayloadAction<any>) {
      state.urbanPiperWebhooksLoading = false;
      state.singleWebhook = action.payload;
    },
    getSingleUrbanPiperWebhookFailed(state, action: PayloadAction<any>) {
      state.urbanPiperWebhooksLoading = false;
      state.message = action.payload?.message;
    },
    setupUrbanPiperWebhook(state, action: PayloadAction<any>) {
      state.setupWebhookLoading = true;
    },
    setupUrbanPiperWebhookSuccess(state, action: PayloadAction<any>) {
      state.setupWebhookLoading = false;
      state.message = action.payload?.message;
    },
    setupUrbanPiperWebhookFailed(state, action: PayloadAction<any>) {
      state.setupWebhookLoading = false;
      state.message = action.payload?.message;
    },
    getDefaultWebhookEvents(state, action?: PayloadAction<any>) {
      state.defaultWebhookEventsLoading = true;
    },
    getDefaultWebhookEventsSuccess(state, action: PayloadAction<any>) {
      state.defaultWebhookEventsLoading = false;
      state.defaultWebhookEvents = action.payload;
    },
    getDefaultWebhookEventsFailed(state, action: PayloadAction<any>) {
      state.defaultWebhookEventsLoading = false;
      state.message = action.payload?.message;
    },
  },
});

//Actions
export const StoreActions = storeSlice.actions;

//Selectors

export const getStoreList = (state: RootState) => state.stores.data;
export const getStoreData = (state: RootState) => state.stores.storeData;
export const getPlatformData = (state: RootState) => state.stores.platformData;
export const getKotData = (state: RootState) => state.stores.KotData;
export const getBrandDataById = (state: RootState) => state.stores.BrandData;
export const selectStoreCharges = (state: RootState) =>
  state.stores.storeCharges?.data;
export const selectStoreTaxes = (state: RootState) =>
  state.stores.storeTaxes?.data;
export const selectIsLoading = (state: RootState) => state.stores.loading;
export const selectIsmenuLoading = (state: RootState) =>
  state.stores.menuLoading;
export const selectAddUpdateLoading = (state: RootState) =>
  state.stores.addUpdateLoading;
export const selectImageLoading = (state: RootState) =>
  state.stores.imageLoading;
export const selectStoreImageUrl = (state: RootState) => state.stores.imageUrl;
export const selectIsSuccess = (state: RootState) => state.stores.success;
export const selectMessage = (state: RootState) => state.platforms.message;
export const getIntegrationData = (state: RootState) => state.stores.integration;
export const getRoleOrdersData = (state: RootState) => state.stores.roleOrders;
export const getConstantsTypeData = (state: RootState) => state.stores.constantsType;
export const selectUrbanPiperWebhooks = (state: RootState) => state.stores.urbanPiperWebhooks;
export const selectUrbanPiperWebhooksLoading = (state: RootState) => state.stores.urbanPiperWebhooksLoading;
export const selectSetupWebhookLoading = (state: RootState) => state.stores.setupWebhookLoading;
export const selectSingleWebhook = (state: RootState) => state.stores.singleWebhook;
export const selectDefaultWebhookEvents = (state: RootState) => state.stores.defaultWebhookEvents;
export const selectDefaultWebhookEventsLoading = (state: RootState) => state.stores.defaultWebhookEventsLoading;

//Reducers
const storeReducer = storeSlice.reducer;
export default storeReducer;

